import { BridgeComponent } from '@hotwired/hotwire-native-bridge';

/**
 * Asks the app to show the system's rating prompt when the element appears, for a moment worth rating such as
 * finishing a journey. The system decides whether to actually show it (it limits how often). Does nothing in a
 * browser or in builds that do not register the component.
 */
export default class ReviewPromptController extends BridgeComponent {
  public static component = 'review-prompt';

  public connect(): void {
    super.connect();
    this.send('request');
  }
}
